module.exports = __webpack_public_path__ + "img/voice-thumb4.0755aeb.jpg";